import { CheckboxSelector } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'
import useCountries from '../../../Model/Countries/List'
import FilterBadge from '../../../common/FilterBadge'

const CountryFilter = (props) => {
  const { translate } = useTranslation()
  const {
    countryFilters,
    setCountryFilters,
    setNamesDataFilters,
    namesDataFilters
  } = props

  const { data: countries } = useCountries({ limit: 0 })
  const countryOptions = (countries?.docs || [])
    .map(item => ({ name: item.name, id: item.id }))
    .sort((a, b) => a.name.localeCompare(b.name))

  return (
    <CheckboxSelector
      setDataFilters={setCountryFilters}
      direction='bottom'
      dataFilters={countryFilters}
      setNamesDataFilters={setNamesDataFilters}
      namesDataFilters={namesDataFilters}
      typeFilter='services'
      data={countryOptions}
      strings={{
        viewAll: translate('filters.plans.viewAll'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search')
      }}
    >
      <FilterBadge
        title={translate('filters.plans.countriesTitle')}
        options={countryOptions}
        selectedIds={countryFilters}
        onClearFilters={() => setCountryFilters([])}
      />
    </CheckboxSelector>
  )
}
export default CountryFilter
